<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
  <app-sub-header [pageTitle]="'Trailers' | translate"></app-sub-header>

  <div class="padded-container">
    <dx-button
      type="success"
      class="full-width-button"
      style="margin-bottom: 10px;"
      (click)="continueWithoutTrailer()"
      text="{{ 'ContinueWithoutTrailer' | translate }}">
    </dx-button>
    <div *ngIf="trailerListResponse?.trailers?.length">
      <dx-text-box
        [(ngModel)]="searchText"
        [showClearButton]="true"
        [valueChangeEvent]="'input'"
        placeholder="{{ 'SearchTrailer' | translate }}"
        class="full-width-button"
        style="margin-bottom: 10px;"
      ></dx-text-box>
      <div class="car-list-box">
        <ng-container *ngIf="filteredTrailers.length > 0; else noMatch">
          <div *ngFor="let trailer of filteredTrailers">
            <dx-button 
              type="default" 
              class="full-width-button"
              (click)="trailer.id ? continueNextStep(trailer.id, trailer.trailerNumber || '') : 0"
              [text]="trailer.driverReserved ? trailer.trailerNumber + ' - ' + trailer.driverReserved : trailer.trailerNumber"
              [icon]="trailer.servVoucherId ? 'optionsgear' : ''"
              [disabled]="!!trailer.driverReserved">
            </dx-button>
          </div>
        </ng-container>
        <ng-template #noMatch>
          <span>{{ 'NoTrailersMatchSearch' | translate }}</span>
        </ng-template>
      </div>
      <dx-button 
        type="danger" 
        class="full-width-button"
        (click)="navigateToVoucher()"
        text="{{ 'Back' | translate }}">
      </dx-button>
    </div>

    <div *ngIf="trailerListResponse && (!trailerListResponse.trailers || trailerListResponse.trailers.length === 0)">
      <span>{{ 'NoAttachedTrailers' | translate }}</span>
      <dx-button 
        type="danger" 
        class="full-width-button"
        (click)="navigateToVoucher()"
        text="{{ 'Back' | translate }}">
      </dx-button>
    </div>
  </div>
</div>
